import React, {useEffect, useState} from 'react';

import {GetIcon} from 'store/enums/normalizedIcons';

import './UpwardButton.scss';

const UpwardButton = () => {
  const [scroll, setScroll] = useState<number>(0);
  const expectedScroll = window.innerHeight * 1.5;

  const handleScroll = () => {
    const scrollTop = window.pageYOffset;
    setScroll(scrollTop);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div
      onClick={() => window.scrollTo({top: 0, behavior: 'smooth'})}
      className={`
        upward-button
        ${scroll > expectedScroll ? 'upward-button__active' : ''}
      `}>
      <GetIcon iconName={'UpwardIcon'} className={'upward-button__icon'} fill={'#000'} secondaryFill={'#000'} />
    </div>
  );
};

export default UpwardButton;
